import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const CustomerOrderCountCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Customer order count",
    cell: (row) => {
      return row?.customer?.numOrders?.toString() ?? "";
    },
  };
